//
import { ModuleLayout } from '@/components/reusable_components/next'

//
import AssetDiscountListView from '@/views/HumanResource/HrAssetDiscount/HrAssetDiscountList'
import AssetDiscountCreateView from '@/views/HumanResource/HrAssetDiscount/HrAssetDiscountCreate'
import AssetDiscountUpdateView from '@/views/HumanResource/HrAssetDiscount/HrAssetDiscountUpdate'

//
export default {
    path: 'asset_discount',
    component: ModuleLayout,
    children: [
        {
            path: '',
            name: 'asset-discount-list',
            component: AssetDiscountListView,
        },
        {
            path: 'add',
            name: 'asset-discount-create',
            component: AssetDiscountCreateView,
            meta: {
                title: 'Crear haber o descuento',
            },
        },
        {
            path: ':id',
            name: 'asset-discount-update',
            component: AssetDiscountUpdateView,
            meta: {
                title: 'Detalles del haber o descuento',
            },
        },
    ],
    meta: {
        title: 'Haberes y descuentos',
    },
}
